import { SuggestedNonprofitCard } from "@components/feed/SuggestedNonprofitCard";
import { MasonryList } from "@components/layout/MasonryList";
import React, { Fragment, useContext } from "react";

import { NonprofitsContext } from "src/context/NonprofitsContext";
import {
  getNonprofit,
  nonprofitOrUndefined,
} from "src/context/NonprofitsContext/selectors";
import { ContextNonprofit } from "src/context/NonprofitsContext/types";

export const Nonprofits: React.FCC<{
  community: ContextNonprofit;
}> = ({ community }) => {
  const { endorsedNonprofitIds } = community;
  const nonprofitsState = useContext(NonprofitsContext);

  const communityNonprofits = endorsedNonprofitIds
    ?.map((id) => nonprofitOrUndefined(getNonprofit(nonprofitsState, { id })))
    .filter((n) => !!n);

  return (
    <Fragment>
      {communityNonprofits && communityNonprofits.length > 0 ? (
        <MasonryList
          items={[
            ...(communityNonprofits as ContextNonprofit[]).map(
              (fundNonprofit) => ({
                key: `nonprofit-${fundNonprofit.id}`,
                elem: (
                  <SuggestedNonprofitCard
                    nonprofit={fundNonprofit}
                    headerText="Supporting in"
                  />
                ),
              })
            ),
          ]}
        />
      ) : (
        <h4>No nonprofits added to this community yet.</h4>
      )}
    </Fragment>
  );
};
